import { ByteArray } from '@/models/cmd';
import { BitArray } from '@/models/cmd/BitArray';
import { GameState } from '@/models/games/enums/GameState';
import { LocalState } from '@/models/games/enums/LocalState';
import { ThaiHiLoRecord, ThaiHiLoResult } from '@/models/games/thaiHiLo';
import { BetType } from '@/models/games/thaiHiLo/BetType';
import { SupportedGameResult } from '@/modules/host/models';
import { GameState as ThaiHiLoState } from '../../models/games/thaiHiLo/GameState';

export const GLIDisableBetTypes = [
    BetType.THLBHi,
    BetType.THLBSpecificDoubleOneTwo,
    BetType.THLBSpecificDoubleOneThree,
    BetType.THLBSpecificDoubleTwoThree,
    BetType.THLBSpecificDoubleThreeFour,
    BetType.THLBSpecificDoubleFourOne,
    BetType.THLBSpecificDoubleFourTwo,
    BetType.THLBSpecificDoubleFourFive,
    BetType.THLBSpecificDoubleFourSix,
    BetType.THLBSpecificDoubleFiveOne,
    BetType.THLBSpecificDoubleFiveTwo,
    BetType.THLBSpecificDoubleFiveThree,
    BetType.THLBSpecificDoubleFiveSix,
    BetType.THLBSpecificDoubleSixOne,
    BetType.THLBSpecificDoubleSixTwo,
    BetType.THLBSpecificDoubleSixThree,
    BetType.THLBOneTwoThree,
    BetType.THLBFourFiveSix,
    BetType.THLBTwoLo,
    BetType.THLBSixHi,
];
export const convertResultStringToRecord = (
    currentResult: SupportedGameResult,
    resultString: string,
    FResult: bigint,
    result?: number
): ThaiHiLoRecord => {
    const arr = resultString.split(',');
    const d1 = parseInt(arr[0]);
    const d2 = parseInt(arr[1]);
    const d3 = parseInt(arr[2]);
    const { GameID, Result, GameCount } = currentResult;
    const updateResult: ThaiHiLoResult = Object.assign(
        {
            Dice1: d1,
            Dice2: d2,
            Dice3: d3,
            FResult: FResult.toString(),
            GameCount: GameCount,
            GameID: GameID,
            Result: result ?? Result,
        },
        getResultForFResult(BigInt(FResult))
    );
    const resultRecord = convertResultToRecord(updateResult);
    return resultRecord;
};

export const convertResultToRecord = (
    result: ThaiHiLoResult
): ThaiHiLoRecord => {
    const [d1, d2, d3] = [result.Dice1, result.Dice2, result.Dice3].sort(
        (a, b) => a - b
    );
    const resultPoint = d1 + d2 + d3;
    let win = -1; //-1 empty, 0 11HiLo, 1 Hi, 2 Lo;
    if (result.THLR11HiLo === 0) {
        win = 1;
    } else if (result.THLR11HiLo === 1) {
        win = 2;
    } else if (result.THLR11HiLo === 2) {
        win = 0;
    }
    const record: ThaiHiLoRecord = {
        gameID: result.GameID,
        result: result.Result,
        shoes: Math.floor(result.GameCount),
        round: result.GameCount % 10000,
        resultPoint: resultPoint,
        Dice1: d1,
        Dice2: d2,
        Dice3: d3,
        Win: win,
        THLR11HiLo: result.THLR11HiLo,
        // 0 - Hi
        // 1 - Lo
        // 2 - 11 HiLo
        THLRSpecificNumber1: result.THLRSpecificNumber1,
        // 0 - No Win
        // 1 - Specific Number 1 appearing 1 time
        // 2 - Specific Number 1 appearing 2 times
        // 3 - Specific Number 1 appearing 3 times
        THLRSpecificNumber2: result.THLRSpecificNumber2,
        // 0 - No Win
        // 1 - Specific Number 2 appearing 1 time
        // 2 - Specific Number 2 appearing 2 times
        // 3 - Specific Number 2 appearing 3 times
        THLRSpecificNumber3: result.THLRSpecificNumber3,
        // 0 - No Win
        // 1 - Specific Number 3 appearing 1 time
        // 2 - Specific Number 3 appearing 2 times
        // 3 - Specific Number 3 appearing 3 times
        THLRSpecificNumber4: result.THLRSpecificNumber4,
        // 0 - No Win
        // 1 - Specific Number 4 appearing 1 time
        // 2 - Specific Number 4 appearing 2 times
        // 3 - Specific Number 4 appearing 3 times
        THLRSpecificNumber5: result.THLRSpecificNumber5,
        // 0 - No Win
        // 1 - Specific Number 5 appearing 1 time
        // 2 - Specific Number 5 appearing 2 times
        // 3 - Specific Number 5 appearing 3 times
        THLRSpecificNumber6: result.THLRSpecificNumber6,
        // 0 - No Win
        // 1 - Specific Number 6 appearing 1 time
        // 2 - Specific Number 6 appearing 2 times
        // 3 - Specific Number 6 appearing 3 times
        THLRSpecificDouble12: result.THLRSpecificDouble12,
        THLRSpecificDouble13: result.THLRSpecificDouble13,
        THLRSpecificDouble23: result.THLRSpecificDouble23,
        THLRSpecificDouble34: result.THLRSpecificDouble34,
        THLRSpecificDouble41: result.THLRSpecificDouble41,
        THLRSpecificDouble42: result.THLRSpecificDouble42,
        THLRSpecificDouble45: result.THLRSpecificDouble45,
        THLRSpecificDouble46: result.THLRSpecificDouble46,
        THLRSpecificDouble51: result.THLRSpecificDouble51,
        THLRSpecificDouble52: result.THLRSpecificDouble52,
        THLRSpecificDouble53: result.THLRSpecificDouble53,
        THLRSpecificDouble56: result.THLRSpecificDouble56,
        THLRSpecificDouble61: result.THLRSpecificDouble61,
        THLRSpecificDouble62: result.THLRSpecificDouble62,
        THLRSpecificDouble63: result.THLRSpecificDouble63,
        THLR123: result.THLR123,
        // 0 - No Win
        // 1 - 123
        // 2 - 12
        // 3 - 23
        // 4 - 13
        THLR456: result.THLR456,
        // 0 - No Win
        // 1 - 456
        // 2 - 45
        // 3 - 56
        // 4 - 45
        THLR1Lo: result.THLR1Lo,
        THLR2Lo: result.THLR2Lo,
        THLR3Lo: result.THLR3Lo,
        THLR4Lo: result.THLR4Lo,
        THLR5Lo: result.THLR5Lo,
        THLR6Lo: result.THLR6Lo,
        THLR3Hi: result.THLR3Hi,
        THLR4Hi: result.THLR4Hi,
        THLR5Hi: result.THLR5Hi,
        THLR6Hi: result.THLR6Hi,
    };

    return record;
};

export const getResultForFResult = (FResult: bigint) => {
    const ba: ByteArray = new ByteArray();
    ba.writeUint64(FResult);
    const bitArray = new BitArray(ba);
    return {
        THLR11HiLo: bitArray.readNumber(2),
        // 0 - Hi
        // 1 - Lo
        // 2 - 11 HiLo
        THLRSpecificNumber1: bitArray.readNumber(3),
        // 0 - No Win
        // 1 - Specific Number 1 appearing 1 time
        // 2 - Specific Number 1 appearing 2 times
        // 3 - Specific Number 1 appearing 3 times
        THLRSpecificNumber2: bitArray.readNumber(3),
        // 0 - No Win
        // 1 - Specific Number 2 appearing 1 time
        // 2 - Specific Number 2 appearing 2 times
        // 3 - Specific Number 2 appearing 3 times
        THLRSpecificNumber3: bitArray.readNumber(3),
        // 0 - No Win
        // 1 - Specific Number 3 appearing 1 time
        // 2 - Specific Number 3 appearing 2 times
        // 3 - Specific Number 3 appearing 3 times
        THLRSpecificNumber4: bitArray.readNumber(3),
        // 0 - No Win
        // 1 - Specific Number 4 appearing 1 time
        // 2 - Specific Number 4 appearing 2 times
        // 3 - Specific Number 4 appearing 3 times
        THLRSpecificNumber5: bitArray.readNumber(3),
        // 0 - No Win
        // 1 - Specific Number 5 appearing 1 time
        // 2 - Specific Number 5 appearing 2 times
        // 3 - Specific Number 5 appearing 3 times
        THLRSpecificNumber6: bitArray.readNumber(3),
        // 0 - No Win
        // 1 - Specific Number 6 appearing 1 time
        // 2 - Specific Number 6 appearing 2 times
        // 3 - Specific Number 6 appearing 3 times
        THLRSpecificDouble12: bitArray.readBoolean(),
        THLRSpecificDouble13: bitArray.readBoolean(),
        THLRSpecificDouble23: bitArray.readBoolean(),
        THLRSpecificDouble34: bitArray.readBoolean(),
        THLRSpecificDouble41: bitArray.readBoolean(),
        THLRSpecificDouble42: bitArray.readBoolean(),
        THLRSpecificDouble45: bitArray.readBoolean(),
        THLRSpecificDouble46: bitArray.readBoolean(),
        THLRSpecificDouble51: bitArray.readBoolean(),
        THLRSpecificDouble52: bitArray.readBoolean(),
        THLRSpecificDouble53: bitArray.readBoolean(),
        THLRSpecificDouble56: bitArray.readBoolean(),
        THLRSpecificDouble61: bitArray.readBoolean(),
        THLRSpecificDouble62: bitArray.readBoolean(),
        THLRSpecificDouble63: bitArray.readBoolean(),
        THLR123: bitArray.readNumber(3),
        // 0 - No Win
        // 1 - 123
        // 2 - 12
        // 3 - 23
        // 4 - 13
        THLR456: bitArray.readNumber(3),
        // 0 - No Win
        // 1 - 456
        // 2 - 45
        // 3 - 56
        // 4 - 45
        THLR1Lo: bitArray.readBoolean(),
        THLR2Lo: bitArray.readBoolean(),
        THLR3Lo: bitArray.readBoolean(),
        THLR4Lo: bitArray.readBoolean(),
        THLR5Lo: bitArray.readBoolean(),
        THLR6Lo: bitArray.readBoolean(),
        THLR3Hi: bitArray.readBoolean(),
        THLR4Hi: bitArray.readBoolean(),
        THLR5Hi: bitArray.readBoolean(),
        THLR6Hi: bitArray.readBoolean(),
    };
};

export const getThaiHiLoWinSet = (FResult: bigint): Array<BetType> => {
    let betTypeWin: BetType[] = [];
    const result = getResultForFResult(FResult);

    if (result.THLR11HiLo == 0) betTypeWin.push(BetType.THLBHi);
    if (result.THLR11HiLo == 1) betTypeWin.push(BetType.THLBLo);
    if (result.THLR11HiLo == 2) betTypeWin.push(BetType.THLBElevenHiLo);

    if (result.THLRSpecificNumber1 > 0)
        betTypeWin.push(BetType.THLBSpecificNumberOne);
    if (result.THLRSpecificNumber2 > 0)
        betTypeWin.push(BetType.THLBSpecificNumberTwo);
    if (result.THLRSpecificNumber3 > 0)
        betTypeWin.push(BetType.THLBSpecificNumberThree);
    if (result.THLRSpecificNumber4 > 0)
        betTypeWin.push(BetType.THLBSpecificNumberFour);
    if (result.THLRSpecificNumber5 > 0)
        betTypeWin.push(BetType.THLBSpecificNumberFive);
    if (result.THLRSpecificNumber6 > 0)
        betTypeWin.push(BetType.THLBSpecificNumberSix);

    if (result.THLRSpecificDouble12)
        betTypeWin.push(BetType.THLBSpecificDoubleOneTwo);
    if (result.THLRSpecificDouble13)
        betTypeWin.push(BetType.THLBSpecificDoubleOneThree);
    if (result.THLRSpecificDouble23)
        betTypeWin.push(BetType.THLBSpecificDoubleTwoThree);
    if (result.THLRSpecificDouble34)
        betTypeWin.push(BetType.THLBSpecificDoubleThreeFour);
    if (result.THLRSpecificDouble41)
        betTypeWin.push(BetType.THLBSpecificDoubleFourOne);
    if (result.THLRSpecificDouble42)
        betTypeWin.push(BetType.THLBSpecificDoubleFourTwo);
    if (result.THLRSpecificDouble45)
        betTypeWin.push(BetType.THLBSpecificDoubleFourFive);
    if (result.THLRSpecificDouble46)
        betTypeWin.push(BetType.THLBSpecificDoubleFourSix);
    if (result.THLRSpecificDouble51)
        betTypeWin.push(BetType.THLBSpecificDoubleFiveOne);
    if (result.THLRSpecificDouble52)
        betTypeWin.push(BetType.THLBSpecificDoubleFiveTwo);
    if (result.THLRSpecificDouble53)
        betTypeWin.push(BetType.THLBSpecificDoubleFiveThree);
    if (result.THLRSpecificDouble56)
        betTypeWin.push(BetType.THLBSpecificDoubleFiveSix);
    if (result.THLRSpecificDouble61)
        betTypeWin.push(BetType.THLBSpecificDoubleSixOne);
    if (result.THLRSpecificDouble62)
        betTypeWin.push(BetType.THLBSpecificDoubleSixTwo);
    if (result.THLRSpecificDouble63)
        betTypeWin.push(BetType.THLBSpecificDoubleSixThree);

    if (result.THLR123 > 0) {
        betTypeWin.push(BetType.THLBOneTwoThree);
        if (result.THLR123 == 2)
            betTypeWin.push(BetType.THLBSpecificDoubleOneTwo);
        if (result.THLR123 == 3)
            betTypeWin.push(BetType.THLBSpecificDoubleTwoThree);
        if (result.THLR123 == 4)
            betTypeWin.push(BetType.THLBSpecificDoubleOneThree);
    }

    if (result.THLR456 > 0) {
        betTypeWin.push(BetType.THLBFourFiveSix);
        if (result.THLR456 == 2)
            betTypeWin.push(BetType.THLBSpecificDoubleFourFive);
        if (result.THLR456 == 3)
            betTypeWin.push(BetType.THLBSpecificDoubleFiveSix);
        if (result.THLR456 == 4)
            betTypeWin.push(BetType.THLBSpecificDoubleFourSix);
    }

    if (result.THLR1Lo) betTypeWin.push(BetType.THLBOneLo);
    if (result.THLR2Lo) betTypeWin.push(BetType.THLBTwoLo);
    if (result.THLR3Lo) betTypeWin.push(BetType.THLBThreeLo);
    if (result.THLR4Lo) betTypeWin.push(BetType.THLBFourLo);
    if (result.THLR5Lo) betTypeWin.push(BetType.THLBFiveLo);
    if (result.THLR6Lo) betTypeWin.push(BetType.THLBSixLo);

    if (result.THLR3Hi) betTypeWin.push(BetType.THLBThreeHi);
    if (result.THLR4Hi) betTypeWin.push(BetType.THLBFourHi);
    if (result.THLR5Hi) betTypeWin.push(BetType.THLBFiveHi);
    if (result.THLR6Hi) betTypeWin.push(BetType.THLBSixHi);

    return betTypeWin;
};

export const getLocalState = (
    isRest: boolean,
    state: number,
    isGameResultReleased: boolean
) => {
    if (isRest) {
        return LocalState.REST;
    }
    switch (state) {
        case GameState.RoundCancel:
            return LocalState.ROUND_CANCEL;
        case GameState.Restart:
            return GameState.Restart;
        case GameState.Idle:
        case GameState.Shuffle:
            return LocalState.IDLE;
        // return LocalState.SHUFFLING;
        case GameState.Betting:
            return LocalState.BETTING;
        case GameState.Started:
        case ThaiHiLoState.WaitResult:
            return LocalState.DEALING;
        case ThaiHiLoState.Hi:
        case ThaiHiLoState.Lo:
        case ThaiHiLoState.HiLo11:
            if (isGameResultReleased) {
                return LocalState.RESULT;
            } else {
                return LocalState.DEALING;
            }
    }

    return LocalState.IDLE;
};
